import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Mail, Phone, Building } from 'lucide-react';
import { format } from 'date-fns';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminContacts = () => {
  const [contacts, setContacts] = useState([]);
  const [selectedContact, setSelectedContact] = useState(null);

  useEffect(() => {
    fetchContacts();
  }, []);

  const fetchContacts = async () => {
    const token = localStorage.getItem('adminToken');
    try {
      const response = await axios.get(`${API}/admin/contacts`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setContacts(response.data);
    } catch (error) {
      console.error('Error:', error);
    }
  };

  return (
    <div data-testid="admin-contacts-page">
      <h1 className="text-3xl font-bold text-primary mb-8">Contact Submissions</h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white shadow-md">
          <div className="divide-y divide-slate-200">
            {contacts.map((contact) => (
              <div
                key={contact.id}
                onClick={() => setSelectedContact(contact)}
                data-testid={`contact-item-${contact.id}`}
                className={`p-6 cursor-pointer hover:bg-muted transition-colors ${
                  selectedContact?.id === contact.id ? 'bg-muted' : ''
                }`}
              >
                <div className="flex justify-between items-start mb-2">
                  <h3 className="text-lg font-bold text-primary">{contact.name}</h3>
                  <span className="text-xs text-muted-foreground">
                    {format(new Date(contact.submitted_at), 'MMM dd, yyyy')}
                  </span>
                </div>
                <p className="text-sm text-muted-foreground line-clamp-2">{contact.message}</p>
              </div>
            ))}
          </div>
        </div>

        <div className="bg-white shadow-md p-6">
          {selectedContact ? (
            <div data-testid="contact-detail">
              <h2 className="text-2xl font-bold text-primary mb-6">Contact Details</h2>
              <div className="space-y-4">
                <div>
                  <label className="text-xs uppercase text-muted-foreground">Name</label>
                  <p className="font-semibold text-primary">{selectedContact.name}</p>
                </div>
                <div>
                  <label className="text-xs uppercase text-muted-foreground">Email</label>
                  <p className="flex items-center text-sm">
                    <Mail size={16} className="mr-2" />
                    <a href={`mailto:${selectedContact.email}`} className="text-blue-600 hover:underline">
                      {selectedContact.email}
                    </a>
                  </p>
                </div>
                <div>
                  <label className="text-xs uppercase text-muted-foreground">Phone</label>
                  <p className="flex items-center text-sm">
                    <Phone size={16} className="mr-2" />
                    {selectedContact.phone}
                  </p>
                </div>
                {selectedContact.company && (
                  <div>
                    <label className="text-xs uppercase text-muted-foreground">Company</label>
                    <p className="flex items-center text-sm">
                      <Building size={16} className="mr-2" />
                      {selectedContact.company}
                    </p>
                  </div>
                )}
                <div>
                  <label className="text-xs uppercase text-muted-foreground">Message</label>
                  <p className="text-sm mt-2 whitespace-pre-wrap">{selectedContact.message}</p>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center text-muted-foreground py-12">
              <p>Select a contact to view details</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminContacts;